"use client";
import React from "react";

// Skeleton Loader สำหรับ Product Showboxes (Carousel Mode)
const ProductShowboxesProductListLoader = () => {
  return (
    <div className="w-full animate-pulse">
      <div className="grid grid-cols-2 lg:grid-cols-4 md:grid-cols-3 gap-y-8 gap-x-4 lg:gap-x-5 w-full">
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            className="flex flex-col gap-6 justify-start items-start w-full h-full"
          >
            <div className={`w-full aspect-square bg-gray-200 rounded-3xl`} />
            <div className="h-4 bg-gray-200 rounded w-5/6" />
            <div className="h-4 bg-gray-200 rounded w-1/2" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductShowboxesProductListLoader;
